import React, { useRef, useEffect, useState, useCallback } from 'react';
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import 'leaflet-routing-machine';
import '../map.css';
import axios from 'axios';
import Sheet from 'react-modal-sheet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../color';
import { v4 as uuidv4 } from 'uuid';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { DislikeFilled, LikeFilled, LikeOutlined, DislikeOutlined, MinusOutlined } from '@ant-design/icons';
import { EnvironmentOutlined, EnvironmentFilled, PlusOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { FaExclamationTriangle, FaTrash } from 'react-icons/fa';
import * as tt from '@tomtom-international/web-sdk-services';
import { io } from 'socket.io-client';
import ErrorComponent from '../component/ErrorComponent';
import { ServerIP, SiteUrl } from '../component/ServerIP';
import Loader from '../component/Loader';
import { ArrowRightOutlined, TagOutlined } from "@ant-design/icons";





const ClientPaymentMap = ({ }) => {

  const params = new URLSearchParams(window.location.search);
  const orderId = params.get('orderId');


  const mapContainer = useRef(null);
  const map = useRef(null);
  const center = { lng: 18.32, lat: -72.17 };
  const [location, setLocation] = useState([18.32, -72.17]);

  const [zoom] = useState(12);

  const [price, setPrice] = useState(0);
  const [price1, setPrice1] = useState(0)
  const [oldPrice, setOldPrice] = useState("")

  const [time, setTime] = useState(0)
  const [kilometer, setKilometer] = useState(0)

  const [clientId, setClientId] = useState(null);
  const [message, setMessage] = useState('');

  const [paymentOption, setPaymentOption] = useState('Cash');
  const [typeMission, setTypeMission] = useState(null);


  const [nbresPassager, setNbresPassager] = useState(1);
  const [isVisible, setIsVisible] = useState(false);
  const [loading, setLoading] = useState(false);



  useEffect(() => {
    if (map.current) return;

    map.current = new L.Map(mapContainer.current, {
      center: L.latLng(center.lat, center.lng),
      zoom: zoom,
      zoomControl: false,
      maxZoom: 20,
      minZoom: 3,
    });


    L.tileLayer('https://api.maptiler.com/maps/streets-v2/style.json?key=wpyZbJOc6hFpTL8ANsqV', {
      // attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd',
      maxZoom: 20
    }).addTo(map.current);

    getCoordinate()

  }, [center.lat, center.lng, zoom]);
  ;

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }


  function convertSecondsFunc(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (hours > 0) {
      return `${hours} heures : ${minutes} minutes`;
    } else {
      return `${minutes} minutes`
    }
  }




  let userMarker = useRef();
  let userMarker2 = useRef();

  const getCoordinate = async () => {

    axios.get(`${ServerIP}/mission/getCoordinateMissionClient/${orderId}`)
      .then(res => {
        if (res.status === 200) {

          //pickup
          const userIcon2 = L.icon({
            iconUrl: require('../data/IconImageMap/riseHand.png'),
            iconSize: [25, 36],
            iconAnchor: [12, 35]
          });

          if (userMarker2.current) {
            userMarker2.current.remove();
          }

          userMarker2.current = L.marker([res.data.pickupLatitude, res.data.pickupLongitude],
            { icon: userIcon2 }).addTo(map.current);


          //delivered
          setLocation([res.data.deliveredLatitude, res.data.deliveredLongitude]);

          if (userMarker.current) {
            userMarker.current.remove();
          }

          userMarker.current = L.marker([res.data.deliveredLatitude, res.data.deliveredLongitude], {
            icon: L.icon({
              iconUrl: require('../data/IconImageMap/Location2.png'),
              iconSize: [30, 41],
              iconAnchor: [12, 41]
            }),
            draggable: false
          }).addTo(map.current);


          map.current.flyTo([res.data.deliveredLatitude, res.data.deliveredLongitude], map.current.getZoom() + 4);

          setPrice(res.data.price)
          setPrice1(res.data.price)


          const times = convertSecondsFunc(parseInt(res.data.duration))
          setTime(times)

          setKilometer(res.data.distance.toFixed(2))

          setClientId(res.data.clientId)
          setPaymentOption(res.data.missions.paymentOption)
          setTypeMission(res.data.missions.type)
        }
      })
      .catch(err => {
        console.log(err)
      })
  }


  const formatBalance = (balance) => {
    let balanceString = balance.toString();

    const length = balanceString.length;

    let startPoint = length % 3;

    startPoint = startPoint === 0 ? 3 : startPoint;

    while (startPoint < length) {
      balanceString = balanceString.slice(0, startPoint) + ',' + balanceString.slice(startPoint);
      startPoint += 4;
    }

    return balanceString
  };


  const upFunction = () => {
    if (nbresPassager < 1) {
      setNbresPassager(prev => prev + 1)
    }
  };

  const downFunction = () => {
    if (nbresPassager > 1) {
      setNbresPassager(prev => prev - 1)
    }
  };


  useEffect(() => {

    if (nbresPassager > 1) {
      setPrice(Math.round(price1 * nbresPassager));
    } else {
      setPrice(Math.round(price1));
    }

  }, [nbresPassager])


  const payedFunction = async () => {
    try {
      if (oldPrice !== "" || 0) {
        setIsVisible(true)

        const data = {
          price: oldPrice,
          nbresPassager: nbresPassager,
          orderId: orderId,
        };

        const response = await axios.post(`${ServerIP}/mission/paymentClient`, data);

        if (response.status === 200) {
          setIsVisible(false)

          setTimeout(() => {
            window.location.href = `${SiteUrl}/clientRoutingMap/?orderId=${orderId}`
          }, 500);
        }
      }


    } catch (error) {

      setLoading(false)
      setIsVisible(false)

      if (error.response) {
        setMessage(error.response.data.message);
      } else {
        console.error("Error while making API request:", error);
      }

    }
  };


  // <span style={{ color: colors.black, fontWeight: '800', fontSize: 24 }}>Payer</span>
  return (

    <div className="map-wrap">

      <div ref={mapContainer} className="map" style={{ zIndex: 0, top: 0, height: '55%' }} />


      <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', flexDirection: 'column', width: '100%', height: '45%', bottom: 20, borderTopRightRadius: 15, borderTopLeftRadius: 15, backgroundColor: colors.white }}>

        <div style={{ flexDirection: 'column', display: 'flex', width: '90%', alignItems: 'center', marginTop: '20px', backgroundColor: 'white' }}>

          <div style={{ width: "100%", padding: "20px" }}>
            {/* Nombre de passagers */}
            <div style={{ marginBottom: "20px" }}>
              <div style={{ fontSize: "16px", fontWeight: 700, fontFamily: 'Inter', color: colors.black }}>
                Nombre de passager(s)
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "30px",
                  marginTop: "10px",
                }}
              >
                <div
                  style={{
                    height: "45px",
                    width: "30%",
                    borderRadius: "10px",
                    backgroundColor: colors.gray2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "18px",
                    fontWeight: 700, fontFamily: 'Inter',
                    color: colors.black,
                  }}
                >
                  {nbresPassager}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                  <div
                    onClick={downFunction}
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: colors.accent,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                  >
                    <MinusOutlined style={{ color: colors.black, fontSize: "15px" }} />
                  </div>
                  <div
                    onClick={upFunction}
                    style={{
                      height: "35px",
                      width: "35px",
                      backgroundColor: colors.accent,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      cursor: "pointer",
                    }}
                  >
                    <PlusOutlined style={{ color: colors.black, fontSize: "15px" }} />
                  </div>
                </div>
              </div>
            </div>

            {/* Faire une offre */}
            <div>
              <div style={{ fontSize: "16px", fontWeight: 700, fontFamily: 'Inter', color: colors.black }}>
                Proposez votre prix
              </div>
              <div style={{ fontSize: "14px", fontWeight: 400, marginTop: "5px", fontFamily: 'Inter', color: colors.gray }}>
                Prix recommandé : <span style={{ fontWeight: 700, fontFamily: 'Inter', }}>{price}</span>. Vous pouvez ajuster ce montant selon vos besoins.
              </div>


              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "20px",
                  borderRadius: "10px",
                  backgroundColor: colors.gray2,
                  padding: "7px",
                }}
              >
                <input
                  type="number"
                  value={oldPrice === "" ? "" : oldPrice}
                  onChange={(e) => {
                    const text = e.target.value;
                    if (text === "" || !isNaN(parseFloat(text))) {
                      setOldPrice(text === "" ? "" : parseFloat(text));
                    }
                  }}
                  placeholder="Entrer votre prix"
                  style={{
                    flex: "1",
                    height: "45px",
                    border: "none",
                    outline: "none",
                    fontWeight: 400, fontFamily: 'Inter',
                    padding: "0 10px",
                    fontSize: "14px",
                    backgroundColor: "transparent",
                  }}
                />
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 700, fontFamily: 'Inter',
                    color: colors.gray,
                  }}
                >
                  HTG
                </span>
              </div>
            </div>
          </div>
        </div>





        <div style={{ display: 'flex', height: '12%' }}>
          {(message) && <ErrorComponent errorMessage={message} />}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {!loading ? (
            <div
              onClick={payedFunction}
              style={{
                width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
              }}>
              {paymentOption === 'Cash' ? 'Suivant' : 'Payer'}
            </div>
          ) : (
            <div
              onClick={() => { }}
              style={{
                width: '90%', display: 'flex', marginLeft: '20px', marginRight: '20px',
                alignItems: 'center', justifyContent: 'center', height: '55px', backgroundColor: "#C0EC4E", borderRadius: '35px',
                fontWeight: 700, fontFamily: 'Inter', color: '#03031B', fontSize: 16
              }}>
              Chargement...
            </div>
          )}
        </div>


        <Loader visible={isVisible} />
      </div >
    </div>

  )
}

export default ClientPaymentMap;


